import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Redirect } from 'react-router';

import Button from '../global/Button';
import {
  removeSelectedRosterIdentity,
  resetFoundRosterIdentities,
} from '../../actions/discover-album-folder';
import OnboardingLayoutScrollableContent from '../../apps/temp/views/onboarding/OnboardingLayout/components/OnboardingLayoutScrollableContent';
import OnboardingLayoutFooter from '../../apps/temp/views/onboarding/OnboardingLayout/components/OnboardingLayoutFooter';
import WaldoSpeechBubble from '../global/WaldoSpeechBubble';
import useAlbumFolderForFaceRecognitionDisabled from '../global/hooks/useAlbumFolderForFaceRecognitionDisabled';
import { PRICING_CATEGORY_TYPE } from '../../constants/pricing-categories';
import DiscoverAlbumFolderNoFrJoinSelectedList from './DiscoverAlbumFolderNoFrJoinSelectedList';
import useNoFrJoinSubmit from './hooks/useNoFrJoinSubmit';

const propTypes = {
  albumFolderId: PropTypes.string,
};

// Legacy confirmation step. The join step now confirms and joins in place,
// so this only serves bookmarks / history entries that still point here.
const DiscoverAlbumFolderNoFrJoinConfirm = ({ albumFolderId }) => {
  const { albumFolder } = useAlbumFolderForFaceRecognitionDisabled({
    albumFolderId,
  });
  const history = useHistory();
  const dispatch = useDispatch();
  const { onJoin, isJoining } = useNoFrJoinSubmit({ albumFolderId });

  const selectedRosterIdentities = useSelector(
    state => state.discoverAlbumFolder.selectedRosterIdentities,
  );

  const isSchoolAndAcademics = (
    albumFolder?.pricing_categories?.records ?? []
  ).some(
    r =>
      r?.pricing_category?.type === PRICING_CATEGORY_TYPE.SCHOOL_AND_ACADEMICS,
  );
  const subjectTerm = isSchoolAndAcademics ? 'student' : 'member';

  if (!selectedRosterIdentities || selectedRosterIdentities.length === 0) {
    return (
      <Redirect to={`/discover/album-folder/${albumFolderId}/no-fr-join`} />
    );
  }

  const onAddAnother = () => {
    dispatch(resetFoundRosterIdentities());
    history.push(`/discover/album-folder/${albumFolderId}/no-fr-join`);
  };

  return (
    <Fragment>
      <WaldoSpeechBubble position="right" className="mb-4">
        Tap join the event below if this is your only {subjectTerm} or add
        another {subjectTerm} below
      </WaldoSpeechBubble>
      <OnboardingLayoutScrollableContent className="w-100">
        <DiscoverAlbumFolderNoFrJoinSelectedList
          albumFolderId={albumFolderId}
          rosterIdentities={selectedRosterIdentities}
          onRemove={rosterIdentity =>
            dispatch(removeSelectedRosterIdentity(rosterIdentity))
          }
          disabled={isJoining}
        />
        <div className="text-center">
          <Button
            btnStyle="link"
            className="mt-2"
            onClick={onAddAnother}
            disabled={isJoining}
          >
            Add another {subjectTerm}
          </Button>
        </div>
      </OnboardingLayoutScrollableContent>
      <OnboardingLayoutFooter>
        <Button
          btnSize="lg"
          className="mt-3"
          onClick={() => onJoin(selectedRosterIdentities)}
          disabled={isJoining}
        >
          {isJoining ? 'Joining...' : 'Join the event'}
        </Button>
      </OnboardingLayoutFooter>
    </Fragment>
  );
};

DiscoverAlbumFolderNoFrJoinConfirm.propTypes = propTypes;

export default DiscoverAlbumFolderNoFrJoinConfirm;
